import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MeterDto } from '@app/api/dmc';

/**
 * Describes a meter in a selection list by serial number, location and meter number.
 *
 * ```html
 *   <option [value]="meter.id">{{ meter | meterOptionLabel }}</option>
 *   // 'Serienummer: SN1 - Placering: ALT1 - Målernummer: M1'
 * ```
 */
@Pipe({
  name: 'meterOptionLabel',
  pure: false,
})
export class MeterOptionLabelPipe implements PipeTransform {
  private readonly translateService = inject(TranslateService);

  transform(meter: MeterDto | null | undefined): string {
    if (!meter) {
      return '';
    }

    const parts = [
      meter.serialNumber ? this.translateService.instant('meteringpoint.meter.option.serialnumber', { value: meter.serialNumber }) : null,
      meter.alternateMeterNumber ? this.translateService.instant('meteringpoint.meter.option.location', { value: meter.alternateMeterNumber }) : null,
      meter.meterNumber
        ? this.translateService.instant('meteringpoint.meter.option.meternumber', { value: meter.meterNumber })
        : this.translateService.instant('meteringpoint.meter.option.nometernumber'),
    ];

    return parts.filter(part => !!part).join(' - ');
  }
}
